import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class IncidentDescription extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'incidentDescription'}
            title={'PROCEDURE P19.0 DESCRIPTION OF THE INCIDENT'}
            exportTitle={'<h2>Procedure P19.0 Description of the Incident</h2>'}
            exportFileName={'incident_description.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (IncidentDescription);
